<template>
  <el-dialog width="500px" append-to-body title="上传合同" :visible.sync="visible" :before-close="handleClose">

    <el-form class="xm-form mgt20" autoComplete="on" :model="invoice" v-loading="loading" :rules="invoiceRules"
      element-loading-text="给我一点时间" label-position="right" ref="invoice" label-width="120px" label-suffix="：">

      <el-form-item label="上传合同" prop="contract">
        <form-file v-model="invoice.contract" :config="{}"></form-file>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button v-waves type="primary" @click.native.prevent="handleUploadContract" :loading="loading">确认上传</el-button>
    </div>

  </el-dialog>
</template>

<script>
import { uploadContract } from '@/api/invoice'

import waves from '@/directive/waves'; // 水波纹指令
import FormFile from "@/components/form/file"
export default {
  name: 'AddInvoice',
  components: {
    FormFile
  },
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    invoiceId: {
      type: Number | String,
      required: true
    },
  },
  watch: {
    visible(value) {
      if (value) {

      }
    }
  },
  created() {
    this.formatPrice = this.utils.formatPrice
  },
  data() {
    return {
      loading: false,
      invoice: {
        contract: [],
      },
      invoiceRules: {
        contract: [
          { required: true, message: '请上传合同', trigger: 'blur' }
        ]
      },
    };
  },
  methods: {
    // 上传合同
    handleUploadContract() {
      // 验证form表单
      this.$refs.invoice.validate((valid) => {
        if (valid) {
          this.loading = true;
          const _invoice = JSON.parse(JSON.stringify(this.invoice));
          _invoice.id = this.invoiceId;
          uploadContract(_invoice).then((response) => {
            this.loading = false;
            // 关闭窗口
            this.handleClose();
            // 触发父组件的callback事件
            this.$emit('success');
            // 弹出操作提示
            this.$message({
              type: 'success',
              message: '保存成功!'
            });
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
    // 关闭窗口
    handleClose() {
      if (this.$refs.invoice) {
        this.$refs.invoice.resetFields();
      }
      // 更新visible参数
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped></style>